var React = require('react');

function LinktreeInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0.0244371 5.4081H3.89115L1.13784 2.74143L2.65537 1.15888L5.27448 3.90031V0H7.55043V3.90031L10.1689 1.15888L11.6864 2.74143L8.93309 5.4081H12.8V7.61368H8.90838L11.6744 10.3551L10.1569 11.9003L6.4001 8.04988L2.64335 11.9003L1.12583 10.3551L3.89115 7.61368H0V5.4081H0.0244371ZM5.28649 10.7663H7.56245V16H5.28649V10.7663Z","fill":"#585CBF"}));
}

LinktreeInline.defaultProps = {"width":"13","height":"16","viewBox":"0 0 13 16","fill":"none"};

module.exports = LinktreeInline;

LinktreeInline.default = LinktreeInline;
